import C from "@/components/forms/FormMaxWidthWrapper.module.css";

import type { ReactNode } from "react";

export function FormMaxWidthWrapper({ children }: { children: ReactNode }) {
    return <div className={C.MaxWidth}>{children}</div>;
}
